export default {
  error: state => state.error,
  formLoading: state => state.formLoading,
  success: state => state.success,
  loading: state => state.loading,
  exportLoading: state => state.exportLoading,
  exportSuccess: state => state.exportSuccess,
  preventNew: state => state.preventNew,
  transaction: state => state.transaction,
  transactions: state => state.transactions,
  paging: state => state.paging,
  downloadLink: state => state.downloadLink,
  accountsWithTotal: state => state.accountsWithTotal,
  transactionsCreated: state => state.transactionsCreated,
  coownerUser: state => state.coownerUser,
  transactionUser: state => state.transactionUser,
  allTransactions: state => state.allTransactions,
};



// WEBPACK FOOTER //
// ./src/components/Syndicates/Syndicate/Transactions/getters.js